import * as moment from 'moment';

export const NETWORK_STATUS_CHANGE_DEBOUNCE_TIME = 2000;
export const JOBS_LOADING_THROTTLING_TIMEOUT = 10000;
export const REPORTS_LOADING_THROTTLING_TIMEOUT = 10000;
export const PLACEMENTS_LOADING_THROTTLING_TIMEOUT = 10000;
export const IN_DISTANT_FEATURE = moment('2100-01-01');
